import React from "react";
import { Button, Modal } from "react-bootstrap";
import LoadAgreement from "../Personalization/LoanAgreement";

const calculatePeriodsPerAnnum = (plan) => {
  return 12 / Number(plan.purchasePeriod);
};
const LoanAgreementButton = ({ employee, plan, onSuccess, openModal }) => {
  const [open, setOpen] = React.useState(openModal || false);
  React.useEffect(() => {
    setOpen(openModal);
  }, [openModal]);
  if (!plan || !employee) {
    return <></>;
  }
  return (
    <>
      <Button onClick={() => setOpen(true)}>Continue</Button>
      <Modal
        show={open}
        onHide={() => setOpen(false)}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal font-secondary"
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Loan Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoadAgreement
            user={employee}
            periodsPerAnnum={calculatePeriodsPerAnnum(plan)}
            onSuccess={onSuccess}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default LoanAgreementButton;
